window.bundleDataJ = {
"Jace-boy": {
displayName: "Jace",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jace Personalized Coloring Experience",
variantId: "49351720730861",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jace_final_cover.png?v=1772483899",
price: "$14.99",
preorder: true
},
{
title: "Jace Dragon Holographic Sticker",
variantId: "49933770719469",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jace_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Jace Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jack-boy": {
displayName: "Jack",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jack Personalized Coloring Experience",
variantId: "49274743292141",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jack_final_cover.png?v=1772483900",
price: "$14.99",
preorder: true
},
{
title: "Jack Dragon Holographic Sticker",
variantId: "49933780320493",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jack_holographic_sticker.png?v=1779648210",
price: "$4.99",
preorder: false
},
{
title: "Jack Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jackson-boy": {
displayName: "Jackson",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jackson Personalized Coloring Experience",
variantId: "49279569297645",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jackson_final_cover_98625e74-1e17-45d3-819d-7b676084938d.png?v=1772483899",
price: "$14.99",
preorder: true
},
{
title: "Jackson Dragon Holographic Sticker",
variantId: "49933775700205",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jackson_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Jackson Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jacob-boy": {
displayName: "Jacob",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jacob Personalized Coloring Experience",
variantId: "49351722598637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jacob_final_cover.png?v=1772483900",
price: "$14.99",
preorder: true
},
{
title: "Jacob Dragon Holographic Sticker",
variantId: "49933770686701",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jacob_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Jacob Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jade-girl": {
displayName: "Jade",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jade Personalized Coloring Experience",
variantId: "49537419477229",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jade_final_cover.png?v=1773200665",
price: "$14.99",
preorder: true
},
{
title: "Jade Unicorn Holographic Sticker",
variantId: "49933757448429",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jade_holographic_sticker.png?v=1780099053",
price: "$4.99",
preorder: false
},
{
title: "Jade Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Jake-boy": {
displayName: "Jake",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jake Personalized Coloring Experience",
variantId: "49654388326637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jake_final_cover.png?v=1773501514",
price: "$14.99",
preorder: true
},
{
title: "Jake Dragon Holographic Sticker",
variantId: "49933754794221",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jake_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Jake Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jamal-boy": {
displayName: "Jamal",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jamal Personalized Coloring Experience",
variantId: "49472198869229",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jamal_final_cover.png?v=1772930016",
price: "$14.99",
preorder: true
},
{
title: "Jamal Dragon Holographic Sticker",
variantId: "49933758922989",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jamal_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Jamal Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"James-boy": {
displayName: "James",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "James Personalized Coloring Experience",
variantId: "49279569395949",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/James_final_cover_1ed7e683-1e02-49d8-99c3-1920d5220320.png?v=1772483900",
price: "$14.99",
preorder: true
},
{
title: "James Dragon Holographic Sticker",
variantId: "49933775667437",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/James_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "James Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jameson-boy": {
displayName: "Jameson",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jameson Personalized Coloring Experience",
variantId: "49351729119469",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jameson_final_cover.png?v=1771691712",
price: "$14.99",
preorder: true
},
{
title: "Jameson Dragon Holographic Sticker",
variantId: "49933770653933",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jameson_holographic_sticker.png?v=1779648205",
price: "$4.99",
preorder: false
},
{
title: "Jameson Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jared-boy": {
displayName: "Jared",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jared Personalized Coloring Experience",
variantId: "49431668621549",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jared_final_cover.png?v=1772388164",
price: "$14.99",
preorder: true
},
{
title: "Jared Dragon Holographic Sticker",
variantId: "49933759742189",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jared_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Jared Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jasmine-girl": {
displayName: "Jasmine",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jasmine Personalized Coloring Experience",
variantId: "49537114734829",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jasmine_final_cover.png?v=1773200665",
price: "$14.99",
preorder: true
},
{
title: "Jasmine Unicorn Holographic Sticker",
variantId: "49933757645037",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jasmine_holographic_sticker.png?v=1780099051",
price: "$4.99",
preorder: false
},
{
title: "Jasmine Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Jason-boy": {
displayName: "Jason",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jason Personalized Coloring Experience",
variantId: "49279569494253",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jasonfinalcover.png?v=1772682267",
price: "$14.99",
preorder: true
},
{
title: "Jason Dragon Holographic Sticker",
variantId: "49933775634669",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jason_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Jason Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jasper-boy": {
displayName: "Jasper",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jasper Personalized Coloring Experience",
variantId: "49279569592557",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jasperfinalcover.png?v=1772678278",
price: "$14.99",
preorder: true
},
{
title: "Jasper Dragon Holographic Sticker",
variantId: "49933775601901",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jasper_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Jasper Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Javier-boy": {
displayName: "Javier",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Javier Personalized Coloring Experience",
variantId: "49414799655149",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Javier.png?v=1772145015",
price: "$14.99",
preorder: true
},
{
title: "Javier Dragon Holographic Sticker",
variantId: "49933760528621",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Javier_holographic_sticker.png?v=1779648212",
price: "$4.99",
preorder: false
},
{
title: "Javier Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jaxon-boy": {
displayName: "Jaxon",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jaxon Personalized Coloring Experience",
variantId: "49274754564333",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jaxon_final_cover.png?v=1772675665",
price: "$14.99",
preorder: true
},
{
title: "Jaxon Dragon Holographic Sticker",
variantId: "49933780254957",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jaxon_holographic_sticker.png?v=1779648206",
price: "$4.99",
preorder: false
},
{
title: "Jaxon Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jaxson-boy": {
displayName: "Jaxson",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jaxson Personalized Coloring Experience",
variantId: "49414800212205",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jaxson.png?v=1772145066",
price: "$14.99",
preorder: true
},
{
title: "Jaxson Dragon Holographic Sticker",
variantId: "49933760495853",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jaxson_holographic_sticker.png?v=1779648211",
price: "$4.99",
preorder: false
},
{
title: "Jaxson Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jay-boy": {
displayName: "Jay",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jay Personalized Coloring Experience",
variantId: "49431679860973",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jay_final_cover.png?v=1772388160",
price: "$14.99",
preorder: true
},
{
title: "Jay Dragon Holographic Sticker",
variantId: "49933759709421",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jay_holographic_sticker.png?v=1779648205",
price: "$4.99",
preorder: false
},
{
title: "Jay Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jayceigh-girl": {
displayName: "Jayceigh",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jayceigh Personalized Coloring Experience",
variantId: "49801323643117",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jayceigh_final_cover.png?v=1775415295",
price: "$14.99",
preorder: true
},
{
title: "Jayceigh Unicorn Holographic Sticker",
variantId: "49933752697069",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jayceigh_holographic_sticker.png?v=1780099053",
price: "$4.99",
preorder: false
},
{
title: "Jayceigh Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Jayden-boy": {
displayName: "Jayden",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jayden Personalized Coloring Experience",
variantId: "49414801719533",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jayden.png?v=1772144967",
price: "$14.99",
preorder: true
},
{
title: "Jayden Dragon Holographic Sticker",
variantId: "49933760463085",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jayden_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Jayden Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jeff-boy": {
displayName: "Jeff",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jeff Personalized Coloring Experience",
variantId: "49472185532653",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jeff_final_cover.png?v=1772930018",
price: "$14.99",
preorder: true
},
{
title: "Jeff Dragon Holographic Sticker",
variantId: "49933758988525",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jeff_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Jeff Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jeremiah-boy": {
displayName: "Jeremiah",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jeremiah Personalized Coloring Experience",
variantId: "49414803456237",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jeremiah.png?v=1772144799",
price: "$14.99",
preorder: true
},
{
title: "Jeremiah Dragon Holographic Sticker",
variantId: "49933760397549",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jeremiah_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Jeremiah Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jeremy-boy": {
displayName: "Jeremy",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jeremy Personalized Coloring Experience",
variantId: "49397143437549",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jeremyfinalcover.png?v=1771597564",
price: "$14.99",
preorder: true
},
{
title: "Jeremy Dragon Holographic Sticker",
variantId: "49933770424557",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jeremy_holographic_sticker.png?v=1779648212",
price: "$4.99",
preorder: false
},
{
title: "Jeremy Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jesse-boy": {
displayName: "Jesse",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jesse Personalized Coloring Experience",
variantId: "49414803816685",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jesse.png?v=1772144885",
price: "$14.99",
preorder: true
},
{
title: "Jesse Dragon Holographic Sticker",
variantId: "49933760364781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jesse_holographic_sticker.png?v=1779648215",
price: "$4.99",
preorder: false
},
{
title: "Jesse Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jessica-girl": {
displayName: "Jessica",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jessica Personalized Coloring Experience",
variantId: "49402718978285",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/JESSICAFINALCOVER.png?v=1771820300",
price: "$14.99",
preorder: true
},
{
title: "Jessica Unicorn Holographic Sticker",
variantId: "49933767901421",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jessica_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Jessica Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Jesus-boy": {
displayName: "Jesus",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jesus Personalized Coloring Experience",
variantId: "49414804439277",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jesus.png?v=1772144688",
price: "$14.99",
preorder: true
},
{
title: "Jesus Dragon Holographic Sticker",
variantId: "49933760332013",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jesus_holographic_sticker.png?v=1779648216",
price: "$4.99",
preorder: false
},
{
title: "Jesus Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jim-boy": {
displayName: "Jim",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jim Personalized Coloring Experience",
variantId: "49412065853677",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/JIM_FINAL_COVER.png?v=1772032667",
price: "$14.99",
preorder: true
},
{
title: "Jim Dragon Holographic Sticker",
variantId: "49933760594157",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jim_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Jim Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jimmy-boy": {
displayName: "Jimmy",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jimmy Personalized Coloring Experience",
variantId: "49412086300909",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/JIMMY_FINAL_COVER.png?v=1772032668",
price: "$14.99",
preorder: true
},
{
title: "Jimmy Dragon Holographic Sticker",
variantId: "49933760561389",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jimmy_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Jimmy Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Joaquin-boy": {
displayName: "Joaquin",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Joaquin Personalized Coloring Experience",
variantId: "49400138662125",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/JOAQUIN_FINAL_COVER.png?v=1771691585",
price: "$14.99",
preorder: true
},
{
title: "Joaquin Dragon Holographic Sticker",
variantId: "49933769572589",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Joaquin_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Joaquin Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jocelyn-girl": {
displayName: "Jocelyn",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jocelyn Personalized Coloring Experience",
variantId: "49279569625325",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jocelyn_final_cover.png?v=1772908493",
price: "$14.99",
preorder: true
},
{
title: "Jocelyn Unicorn Holographic Sticker",
variantId: "49933775569133",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jocelyn_holographic_sticker.png?v=1780099051",
price: "$4.99",
preorder: false
},
{
title: "Jocelyn Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Joel-boy": {
displayName: "Joel",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Joel Personalized Coloring Experience",
variantId: "49400142659821",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/JOEL_FINAL_COVER.png?v=1771691586",
price: "$14.99",
preorder: true
},
{
title: "Joel Dragon Holographic Sticker",
variantId: "49933769507053",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Joel_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Joel Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"John-boy": {
displayName: "John",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "John Personalized Coloring Experience",
variantId: "49400145903853",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/JOHN_FINAL_COVER.png?v=1771691585",
price: "$14.99",
preorder: true
},
{
title: "John Dragon Holographic Sticker",
variantId: "49933769474285",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/John_holographic_sticker.png?v=1779648206",
price: "$4.99",
preorder: false
},
{
title: "John Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jon-boy": {
displayName: "Jon",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jon Personalized Coloring Experience",
variantId: "49412002939117",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/JON_FINAL_COVER.png?v=1772032667",
price: "$14.99",
preorder: true
},
{
title: "Jon Dragon Holographic Sticker",
variantId: "49933766689005",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jon_holographic_sticker.png?v=1779648210",
price: "$4.99",
preorder: false
},
{
title: "Jon Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jonah-boy": {
displayName: "Jonah",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jonah Personalized Coloring Experience",
variantId: "49400150294765",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/JONAH_FINAL_COVER.png?v=1771691587",
price: "$14.99",
preorder: true
},
{
title: "Jonah Dragon Holographic Sticker",
variantId: "49933769441517",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jonah_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Jonah Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jonalyn-girl": {
displayName: "Jonalyn",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jonalyn Personalized Coloring Experience",
variantId: "49983110807789",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jonalynfinalcover_4ffddc8c-b56e-404a-a292-e082efeb42fe.png?v=1779028480",
price: "$14.99",
preorder: true
},
{
title: "Jonalyn Unicorn Holographic Sticker",
variantId: "49983086362861",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jonalyn_holographic_sticker.png?v=1779378943",
price: "$4.99",
preorder: false
},
{
title: "Jonalyn Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Jonathan-boy": {
displayName: "Jonathan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jonathan Personalized Coloring Experience",
variantId: "49274747715821",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jonathanfinalcover.png?v=1772683395",
price: "$14.99",
preorder: true
},
{
title: "Jonathan Dragon Holographic Sticker",
variantId: "49933780287725",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jonathan_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Jonathan Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jordan-boy": {
displayName: "Jordan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jordan Personalized Coloring Experience",
variantId: "49400157372653",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/JORDAN_FINAL_COVER.png?v=1771691586",
price: "$14.99",
preorder: true
},
{
title: "Jordan Dragon Holographic Sticker",
variantId: "49933769408749",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jordan_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Jordan Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jorge-boy": {
displayName: "Jorge",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jorge Personalized Coloring Experience",
variantId: "49400158748909",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/JORGE_FINAL_COVER.png?v=1771691586",
price: "$14.99",
preorder: true
},
{
title: "Jorge Dragon Holographic Sticker",
variantId: "49933769375981",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jorge_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Jorge Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Jose-boy": {
displayName: "Jose",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jose Personalized Coloring Experience",
variantId: "49400160846061",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/JOSE_FINAL_COVER.png?v=1771691585",
price: "$14.99",
preorder: true
},
{
title: "Jose Dragon Holographic Sticker",
variantId: "49933769343213",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jose_holographic_sticker.png?v=1779648212",
price: "$4.99",
preorder: false
},
{
title: "Jose Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Joseph-boy": {
displayName: "Joseph",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Joseph Personalized Coloring Experience",
variantId: "49400162124013",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/JOSEPH_FINAL_COVER.png?v=1771691586",
price: "$14.99",
preorder: true
},
{
title: "Joseph Dragon Holographic Sticker",
variantId: "49933769310445",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Joseph_holographic_sticker.png?v=1779648212",
price: "$4.99",
preorder: false
},
{
title: "Joseph Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Josh-boy": {
displayName: "Josh",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Josh Personalized Coloring Experience",
variantId: "49431408115949",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Josh_final_cover.png?v=1772388162",
price: "$14.99",
preorder: true
},
{
title: "Josh Dragon Holographic Sticker",
variantId: "49933760069869",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Josh_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Josh Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Joshua-boy": {
displayName: "Joshua",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Joshua Personalized Coloring Experience",
variantId: "49400162779373",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/JOSHUA_FINAL_COVER.png?v=1771691586",
price: "$14.99",
preorder: true
},
{
title: "Joshua Dragon Holographic Sticker",
variantId: "49933769244909",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Joshua_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Joshua Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Josiah-boy": {
displayName: "Josiah",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Josiah Personalized Coloring Experience",
variantId: "49400164417773",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/JOSIAH_FINAL_COVER.png?v=1771691587",
price: "$14.99",
preorder: true
},
{
title: "Josiah Dragon Holographic Sticker",
variantId: "49933769212141",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Josiah_holographic_sticker.png?v=1779648212",
price: "$4.99",
preorder: false
},
{
title: "Josiah Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Josue-boy": {
displayName: "Josue",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Josue Personalized Coloring Experience",
variantId: "49397299380461",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Josuefinalcover.png?v=1771597742",
price: "$14.99",
preorder: true
},
{
title: "Josue Dragon Holographic Sticker",
variantId: "49933770391789",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Josue_holographic_sticker.png?v=1779648212",
price: "$4.99",
preorder: false
},
{
title: "Josue Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Juan-boy": {
displayName: "Juan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Juan Personalized Coloring Experience",
variantId: "49400164712685",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/JUAN_FINAL_COVER.png?v=1771691586",
price: "$14.99",
preorder: true
},
{
title: "Juan Dragon Holographic Sticker",
variantId: "49933769179373",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Juan_holographic_sticker.png?v=1779648210",
price: "$4.99",
preorder: false
},
{
title: "Juan Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Judson-boy": {
displayName: "Judson",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Judson Personalized Coloring Experience",
variantId: "49929631662317",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Judson_final_cover.png?v=1777856679",
price: "$14.99",
preorder: true
},
{
title: "Judson Dragon Holographic Sticker",
variantId: "49933746045165",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Judson_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Judson Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Julia-girl": {
displayName: "Julia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Julia Personalized Coloring Experience",
variantId: "49537184268525",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Julia_final_cover.png?v=1773200664",
price: "$14.99",
preorder: true
},
{
title: "Julia Unicorn Holographic Sticker",
variantId: "49933757513965",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Julia_holographic_sticker.png?v=1780099053",
price: "$4.99",
preorder: false
},
{
title: "Julia Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Julian-boy": {
displayName: "Julian",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Julian Personalized Coloring Experience",
variantId: "49265125589229",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Julianfinalcover.png?v=1772682338",
price: "$14.99",
preorder: true
},
{
title: "Julian Dragon Holographic Sticker",
variantId: "49933781500141",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Julian_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Julian Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Juliana-girl": {
displayName: "Juliana",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Juliana Personalized Coloring Experience",
variantId: "49279569789165",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Julianafinalfinalcover.png?v=1773327402",
price: "$14.99",
preorder: true
},
{
title: "Juliana Unicorn Holographic Sticker",
variantId: "49933775536365",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Juliana_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Juliana Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Juliette-girl": {
displayName: "Juliette",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Juliette Personalized Coloring Experience",
variantId: "49279569854701",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Juliette_final_cover.png?v=1772908493",
price: "$14.99",
preorder: true
},
{
title: "Juliette Unicorn Holographic Sticker",
variantId: "49933775503597",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Juliette_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Juliette Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Juniper-girl": {
displayName: "Juniper",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Juniper Personalized Coloring Experience",
variantId: "49339309195501",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Juniper_final_cover.png?v=1773766535",
price: "$14.99",
preorder: true
},
{
title: "Juniper Unicorn Holographic Sticker",
variantId: "49933772488941",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Juniper_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Juniper Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Justin-boy": {
displayName: "Justin",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Justin Personalized Coloring Experience",
variantId: "49400165368045",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/JUSTIN_FINAL_COVER.png?v=1771691584",
price: "$14.99",
preorder: true
},
{
title: "Justin Dragon Holographic Sticker",
variantId: "49933769113837",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Justin_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Justin Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Jane-girl": {
displayName: "Jane",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jane Personalized Coloring Experience",
variantId: "50042325926125",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jane_final_cover.png?v=1780107471",
price: "$14.99",
preorder: true
},
{
title: "Jane Unicorn Holographic Sticker",
variantId: "50042182009069",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jane_holographic_sticker.png?v=1780099045",
price: "$4.99",
preorder: false
},
{
title: "Jane Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Jean-girl": {
displayName: "Jean",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jean Personalized Coloring Experience",
variantId: "50042372653293",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jean_final_cover.png?v=1780107478",
price: "$14.99",
preorder: true
},
{
title: "Jean Unicorn Holographic Sticker",
variantId: "50042184270061",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jean_holographic_sticker.png?v=1780099051",
price: "$4.99",
preorder: false
},
{
title: "Jean Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Josephine-girl": {
displayName: "Josephine",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Josephine Personalized Coloring Experience",
variantId: "50056816951533",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Josephine_final_cover.png?v=1780209146",
price: "$14.99",
preorder: true
},
{
title: "Josephine Unicorn Holographic Sticker",
variantId: "50056840872173",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Josephine_holographic_sticker.png?v=1780206655",
price: "$4.99",
preorder: false
},
{
title: "Josephine Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Josie-girl": {
displayName: "Josie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Josie Personalized Coloring Experience",
variantId: "50056824586477",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Josie_final_cover.png?v=1780209145",
price: "$14.99",
preorder: true
},
{
title: "Josie Unicorn Holographic Sticker",
variantId: "50056945664237",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Josie_holographic_sticker.png?v=1780206655",
price: "$4.99",
preorder: false
},
{
title: "Josie Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Jayce-boy": {
displayName: "Jayce",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jayce Personalized Coloring Experience",
variantId: "50127685419245",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jaycefinalcover.png?v=1781987658",
price: "$14.99",
preorder: true
},
{
title: "Jayce Dragon Holographic Sticker",
variantId: "50127661629677",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jaycewebsitesticker.png?v=1781986667",
price: "$4.99",
preorder: false
},
{
title: "Jayce Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Jude-boy": {
displayName: "Jude",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jude Personalized Coloring Experience",
variantId: "50127711109357",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Judefinalcover.png?v=1781988366",
price: "$14.99",
preorder: true
},
{
title: "Jude Dragon Holographic Sticker",
variantId: "50127681356013",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Judewebsitesticker.png?v=1781987460",
price: "$4.99",
preorder: false
},
{
title: "Jude Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Judah-boy": {
displayName: "Judah",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Judah Personalized Coloring Experience",
variantId: "50180873486573",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Judah_final_cover.png?v=1782611299",
price: "$14.99",
preorder: true
},
{
title: "Judah Dragon Holographic Sticker",
variantId: "50180785307885",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Judahwebsitesticker.png?v=1782610147",
price: "$4.99",
preorder: false
},
{
title: "Judah Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"June-girl": {
displayName: "June",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "June Personalized Coloring Experience",
variantId: "50246176178413",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/June_final_cover.png?v=1783795017",
price: "$14.99",
preorder: true
},
{
title: "June Unicorn Holographic Sticker",
variantId: "50274680733933",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Juneholographicsticker.png?v=1783828173",
price: "$4.99",
preorder: false
},
{
title: "June Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Jett-boy": {
displayName: "Jett",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jett Personalized Coloring Experience",
variantId: "50399111610605",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jett_final_cover.png?v=1784947223",
price: "$14.99",
preorder: true
},
{
title: "Jett Dragon Holographic Sticker",
variantId: "50399533465837",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jett_holographic_sticker.png?v=1784945963",
price: "$4.99",
preorder: false
},
{
title: "Jett Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Jax-boy": {
displayName: "Jax",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jax Personalized Coloring Experience",
variantId: "50457723175149",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jax_final_cover.png?v=1786406748",
price: "$14.99",
preorder: true
},
{
title: "Jax Dragon Holographic Sticker",
variantId: "50457689293037",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jax_holographic_sticker.png?v=1786406786",
price: "$4.99",
preorder: false
},
{
title: "Jax Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Journee-girl": {
displayName: "Journee",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Journee Personalized Coloring Experience",
variantId: "50519271768301",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Journee_final_cover.png?v=1786941539",
price: "$14.99",
preorder: true
},
{
title: "Journee Unicorn Holographic Sticker",
variantId: "50497548517613",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Journee_holographic_sticker.png?v=1787505458",
price: "$4.99",
preorder: false
},
{
title: "Journee Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Jordyn-girl": {
displayName: "Jordyn",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Jordyn Personalized Coloring Experience",
variantId: "50643933462765",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jordyn_final_cover.png?v=1788490620",
price: "$14.99",
preorder: true
},
{
title: "Jordyn Unicorn Holographic Sticker",
variantId: "50643948011757",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Jordyn_holographic_sticker.png?v=1788490590",
price: "$4.99",
preorder: false
},
{
title: "Jordyn Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 








};